/*
 * @Description:确定线路的api
 * @Author: sunxiaodong
 * @Date: 2020-08-07 19:21:49
 * @LastEditors: sunxiaodong
 * @LastEditTime: 2020-08-19 17:02:51
 */
import http from "e6-base-core/axios/config";
import { e6ModuleOrderWaybillProcessApi } from "@/config/api";
const { host, E6_MS_TMS_BUSI_WEB } = e6ModuleOrderWaybillProcessApi;
// let mock =
//   "http://easymock.dev.e6gpshk.com:30081/mock/5f1e38353d490a0020085529";
// 从转运调度跳转，根据订单智能排线
export function intelligentByOrders(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/addWaybill`,
    method: "post",
    data
  });
}

// 根据订单id数组查询订单详情
export function getDetailByOrderIds(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/findOrderNode`,
    method: "post",
    data
  });
}

// 生成运单
export function generateWaybill(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/generateWaybillFromOrder`,
    method: "post",
    data
  });
}
// 件数
export function countWaybillGoodsNum(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/orderInfo/countWaybillGoodsNum`,
    method: "post",
    data
  });
}
// 获取导航
export function getTruckDrivingLonLat(data) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/navigation/getTruckDrivingLonLat`,
    method: "post",
    data
  });
}

// 获取配送类型
export function getDeliveryType(params) {
  return http({
    url: `${host}${E6_MS_TMS_BUSI_WEB}/waybill/getDeliveryType`,
    method: "get",
    params
  });
}
